/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReferTaskToCommand } from '../../models/refer-task-to-command';
import { ReferTaskToCommandResult } from '../../models/refer-task-to-command-result';

export interface ApiTaskReferTaskToPut$Plain$Params {
      body?: ReferTaskToCommand
}

export function apiTaskReferTaskToPut$Plain(http: HttpClient, rootUrl: string, params?: ApiTaskReferTaskToPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ReferTaskToCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskReferTaskToPut$Plain.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReferTaskToCommandResult>;
    })
  );
}

apiTaskReferTaskToPut$Plain.PATH = '/api/Task/ReferTaskTo';
